import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MdSearchOff } from 'react-icons/md'; // ícone de lupa/erro

const NotFound = () => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        background: 'linear-gradient(135deg, #f5f7fa, #F8C80A)',
        textAlign: 'center',
        fontFamily: 'Arial, sans-serif',
        flexDirection: 'column',
        padding: '20px',
      }}
    >
      {/* Número 404 com animação */}
      <motion.div
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20 }}
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
      >
        <motion.span
          animate={{ rotate: [0, 10, -10, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ fontSize: '8rem', color: '#00731F', marginRight: '10px' }}
        >
          4
        </motion.span>
        <MdSearchOff size={80} color="#00731F" style={{ margin: '0 10px' }} />
        <motion.span
          animate={{ rotate: [0, -10, 10, -10, 0] }}
          transition={{ repeat: Infinity, duration: 2 }}
          style={{ fontSize: '8rem', color: '#00731F', marginLeft: '10px' }}
        >
          4
        </motion.span>
      </motion.div>

      {/* Subtítulo */}
      <motion.h2
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.5, duration: 0.5 }}
        style={{ fontSize: '2rem', color: '#333', margin: '20px 0 10px' }}
      >
        Página Não Encontrada
      </motion.h2>

      {/* Texto explicativo */}
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.7, duration: 0.5 }}
        style={{ fontSize: '1rem', color: '#555', marginBottom: '30px' }}
      >
        Desculpe, a página que você está procurando não existe.
      </motion.p>

      {/* Botão */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 1, duration: 0.5 }}
      >
        <Link
          to="/"
          style={{
            display: 'inline-block',
            padding: '12px 25px',
            backgroundColor: '#00731F',
            color: '#fff',
            textDecoration: 'none',
            borderRadius: '25px',
            fontWeight: 'bold',
          }}
        >
          Voltar para Home
        </Link>
      </motion.div>
    </div>
  );
};

export default NotFound;
